import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";

import PsContext from "../../context";
import { APP_TYPE, formToObject, momentDate } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import OpenPaymentFormLink from "../openPaymentForm/openPaymentFormLink";
import CollegeLogo from "../../app/collegeLogo";
import { TextField, Button } from "@mui/material";
import Footer from "../../app/footer";

const StudentLogin = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const params = useParams();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() == false) {
      e.stopPropagation();
      setValidated(true);
      Toast.show({ content: "Enter Register no & Dob" });
      return;
    }
    context.setLoader(true);
    if (APP_TYPE != "SAAS") {
      checkLogin(form);
      return;
    }
    let fx = formToObject(form);
    const f = new FormData();

    f.append("username", fx.registerno + "@" + context.dbPostfix);
    axios.post(ServiceUrl.LOGIN_V2.CHECK, f).then((res) => {
      if (res["data"].status == "1") {
        axios.defaults.headers.common["Api-Token"] = `${res["data"].api}`;
        //setRedirect(res["data"].data);
        checkLogin(form);
      } else {
        Toast.show({
          content: res["data"].message || "Error",
          position: "top",
        });
        setLoader(false);
      }
      context.setLoader(false);
    });
  };

  const checkLogin = (form) => {
    context.setLoader(true);
    axios.post(ServiceUrl.STUDENTS.LOGIN, new FormData(form)).then((res) => {
      if (res["data"].status == "1") {
        context.setStorage("mob_attendance_date", "");
        axios.defaults.headers.common["Api-Token"] = `${res["data"].api}`;
        context.saveLogin(
          res["data"].data,
          res["data"].api,
          res["data"].permissions,
          []
        );
        context.updateAcyear(res["data"].acyear);
        context.setStorage("login_by", "student");
        context.updateLogged();
      } else {
        //Toast.show({ content: res["data"].message || "Error" });
        context.setAlertMsg(res.data.message || "Error");
      }
      context.setLoader(false);
    });
  };

  const maxDate = () => {
    let y = momentDate(new Date(), "YYYY") - 16;
    let d = momentDate(new Date(), "DD");
    let m = momentDate(new Date(), "MM");
    return momentDate(y + "-" + m + "-" + d, "YYYY-MM-DD");
  };

  if (context.logged == "yes") {
    //history.push("/app");
    return <Navigate to="/stu/app" replace={true} />;
    return null;
  }
  return (
    <>
      <Header
        title="Student Login"
        backAction={[]}
        rightActions={[]}
        onBack={(e) => navigate("/")}
      />

      <div data-aos="zoom-in" className="mt-2">
        <CollegeLogo />
        <div className="container p-3">
          <Row>
            <Col md={{ span: 6, offset: 3 }}>
              <Form
                action=""
                method="post"
                noValidate
                validated={validated}
                onSubmit={handleFormSubmit}
              >
                <input
                  type="hidden"
                  name="college_uuid"
                  value={params.college_uuid}
                />
                <Row className="mt-4">
                  <Col md={12}>
                    <TextField
                      id="outlined-basic"
                      label="Register Number (or) Admission Number"
                      variant="outlined"
                      name="registerno"
                      fullWidth
                      className="bg-white"
                      required
                      autoFocus={true}
                    />
                    {/**<label>
                  Register No <span className="text-danger">*</span>
                </label>
                <Form.Control
                  type="text"
                  name="registerno"
                  required
                  placeholder="Register No"
                  className="fw-bold"
                />*/}
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col md={12}>
                    <label className="fw-bold">
                      Date of Birth <span className="text-danger">*</span>
                    </label>
                    <Form.Control
                      type="date"
                      name="dob"
                      className="fw-bold"
                      max={maxDate()}
                      required
                    />
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col md={12}>
                    <Button
                      type="submit"
                      className="w-100 bg-theme"
                      size="large"
                      variant="contained"
                    >
                      Login
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
          <OpenPaymentFormLink />
        </div>
      </div>

      <Footer />
    </>
  );
};
export default StudentLogin;
